// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_solution_suggestions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureSolutionRevision } from "./capture_solution_pb";
/**
 * SAD-504 SOL-08: reviewable AI suggestion against ONE text field of the
 * Solution Concept head. A suggestion is never a revision until it is applied.
 *
 * @generated from message mono.projectdata.v1.CaptureSolutionSuggestion
 */ export class CaptureSolutionSuggestion extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionSuggestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionSuggestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionSuggestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionSuggestion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string base_revision_id = 4;
   */ _define_property(this, "baseRevisionId", ""), /**
   * approach | intended_outcomes | rationale | constraints | unresolved_issues
   *
   * @generated from field: string target_field = 5;
   */ _define_property(this, "targetField", ""), /**
   * @generated from field: string proposed_text = 6;
   */ _define_property(this, "proposedText", ""), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string provider = 8;
   */ _define_property(this, "provider", ""), /**
   * pending | applied | rejected
   *
   * @generated from field: string state = 9;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string reviewed_by = 12;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 13;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: string applied_revision_id = 14;
   */ _define_property(this, "appliedRevisionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionSuggestion, "runtime", proto3);
_define_property(CaptureSolutionSuggestion, "typeName", "mono.projectdata.v1.CaptureSolutionSuggestion");
_define_property(CaptureSolutionSuggestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "applied_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Asks the configured AI provider for suggestions against the saved head.
 * Requires a saved revision (FailedPrecondition otherwise). Provider failure or
 * timeout is Unavailable and persists nothing.
 *
 * @generated from message mono.projectdata.v1.GenerateCaptureSolutionSuggestionsRequest
 */ export class GenerateCaptureSolutionSuggestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateCaptureSolutionSuggestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateCaptureSolutionSuggestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateCaptureSolutionSuggestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateCaptureSolutionSuggestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateCaptureSolutionSuggestionsRequest, "runtime", proto3);
_define_property(GenerateCaptureSolutionSuggestionsRequest, "typeName", "mono.projectdata.v1.GenerateCaptureSolutionSuggestionsRequest");
_define_property(GenerateCaptureSolutionSuggestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GenerateCaptureSolutionSuggestionsResponse
 */ export class GenerateCaptureSolutionSuggestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateCaptureSolutionSuggestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateCaptureSolutionSuggestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateCaptureSolutionSuggestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateCaptureSolutionSuggestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The new pending suggestions (may be empty if the model proposed nothing usable).
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionSuggestion suggestions = 1;
   */ _define_property(this, "suggestions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateCaptureSolutionSuggestionsResponse, "runtime", proto3);
_define_property(GenerateCaptureSolutionSuggestionsResponse, "typeName", "mono.projectdata.v1.GenerateCaptureSolutionSuggestionsResponse");
_define_property(GenerateCaptureSolutionSuggestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "suggestions",
            kind: "message",
            T: CaptureSolutionSuggestion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureSolutionSuggestionsRequest
 */ export class ListCaptureSolutionSuggestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionSuggestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionSuggestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionSuggestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionSuggestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * Optional filter: pending | applied | rejected. Empty returns all.
   *
   * @generated from field: string state = 2;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionSuggestionsRequest, "runtime", proto3);
_define_property(ListCaptureSolutionSuggestionsRequest, "typeName", "mono.projectdata.v1.ListCaptureSolutionSuggestionsRequest");
_define_property(ListCaptureSolutionSuggestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureSolutionSuggestionsResponse
 */ export class ListCaptureSolutionSuggestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionSuggestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionSuggestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionSuggestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionSuggestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Newest first.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionSuggestion suggestions = 1;
   */ _define_property(this, "suggestions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionSuggestionsResponse, "runtime", proto3);
_define_property(ListCaptureSolutionSuggestionsResponse, "typeName", "mono.projectdata.v1.ListCaptureSolutionSuggestionsResponse");
_define_property(ListCaptureSolutionSuggestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "suggestions",
            kind: "message",
            T: CaptureSolutionSuggestion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewCaptureSolutionSuggestionRequest
 */ export class ReviewCaptureSolutionSuggestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCaptureSolutionSuggestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCaptureSolutionSuggestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCaptureSolutionSuggestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCaptureSolutionSuggestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string suggestion_id = 2;
   */ _define_property(this, "suggestionId", ""), /**
   * apply | reject
   *
   * @generated from field: string decision = 3;
   */ _define_property(this, "decision", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCaptureSolutionSuggestionRequest, "runtime", proto3);
_define_property(ReviewCaptureSolutionSuggestionRequest, "typeName", "mono.projectdata.v1.ReviewCaptureSolutionSuggestionRequest");
_define_property(ReviewCaptureSolutionSuggestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "suggestion_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewCaptureSolutionSuggestionResponse
 */ export class ReviewCaptureSolutionSuggestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCaptureSolutionSuggestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCaptureSolutionSuggestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCaptureSolutionSuggestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCaptureSolutionSuggestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionSuggestion suggestion = 1;
   */ _define_property(this, "suggestion", void 0), /**
   * Set only for decision=apply: the new head revision.
   *
   * @generated from field: mono.projectdata.v1.CaptureSolutionRevision revision = 2;
   */ _define_property(this, "revision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCaptureSolutionSuggestionResponse, "runtime", proto3);
_define_property(ReviewCaptureSolutionSuggestionResponse, "typeName", "mono.projectdata.v1.ReviewCaptureSolutionSuggestionResponse");
_define_property(ReviewCaptureSolutionSuggestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "suggestion",
            kind: "message",
            T: CaptureSolutionSuggestion
        },
        {
            no: 2,
            name: "revision",
            kind: "message",
            T: CaptureSolutionRevision
        }
    ]));
